import React from 'react';

import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router';

import NotFound from '@helsenorge/core-framework/page-not-found';
import { getPath, getAssetsUrl } from '@helsenorge/framework-utils/hn-page';
import WebCompConsumer from '@helsenorge/framework-utils/web-component/consumer';

import Behandlinger from './behandlinger';
import Behandlingssteder from './behandlingssteder';
import Forside from './forside';
import PageContainer from './shared/page-container';
import PageContainerMedBrodsmule from './shared/page-container-med-brodsmule';
import { store } from './store';
import { Urls } from './types/ExtendEnums';
import VentetiderForBehandling from './ventetider-for-behandling';

import './styles.scss';

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: (
        <PageContainer pageClass="vbs-forside" hasFullwidth>
          <Forside />
        </PageContainer>
      ),
    },
    {
      path: Urls.Behandlinger,
      element: (
        <PageContainerMedBrodsmule
          pageClass="vbs-behandlinger"
          breadcrumbResourceId="page_VelgBehandlingssted_NavigateBackLinkTitle"
          breadcrumbUrl="/"
        >
          <Behandlinger />
        </PageContainerMedBrodsmule>
      ),
    },
    {
      path: Urls.VentetiderForBehandling,
      element: (
        <PageContainerMedBrodsmule
          pageClass="vbs-ventetider-for-behandling"
          breadcrumbResourceId="page_Behandlinger_NavigateBackLinkTitle"
          breadcrumbUrl={Urls.Behandlinger}
        >
          <VentetiderForBehandling />
        </PageContainerMedBrodsmule>
      ),
    },
    {
      path: Urls.Behandlingssteder,
      element: (
        <PageContainerMedBrodsmule
          pageClass="vbs-behandlingssteder"
          breadcrumbResourceId="page_VelgBehandlingssted_NavigateBackLinkTitle"
          breadcrumbUrl="/"
        >
          <Behandlingssteder />
        </PageContainerMedBrodsmule>
      ),
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
  { basename: '/' + getPath() }
);

async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (import.meta.env.MODE !== 'mocks') {
    return;
  }

  const { worker } = await import('./mocks/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('main-content-wrapper')!).render(
    <React.StrictMode>
      <React.Fragment>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>

        <WebCompConsumer
          domain={`${getAssetsUrl()}/cms-blocks`}
          entryName="src/index.tsx"
          componentName="hn-webcomp-cms-block-promopanel"
          componentProps={{ externalid: 'velg-behandlingssted' }}
          includeHelsenorgeCss
        />
      </React.Fragment>
    </React.StrictMode>
  );
});
